var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0292 16.6198L26.9541 28.4215C27.4217 28.8843 28.1232 28.8843 28.5908 28.4215C29.0585 27.9587 29.0585 27.2645 28.5908 26.8017L16.666 15L28.8246 3.19835C29.0585 2.73554 29.0585 1.80992 28.8246 1.34711C28.5908 0.884297 27.4217 1.1157 26.9541 1.34711L15.0292 13.1488L3.10439 1.34711C2.63675 0.884296 1.93528 0.884296 1.46764 1.34711C1 1.57851 1 2.04132 1 2.27273C1 2.50413 1 2.96694 1.23382 3.19835L13.1587 15L1.23382 26.8017C1 27.0331 1 27.2645 1 27.7273C1 28.1901 1 28.4215 1.23382 28.6529C1.70146 29.1157 2.40292 29.1157 2.87056 28.6529L15.0292 16.6198Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosem);
export default __webpack_public_path__ + "static/media/closem.2e970eae860624fc5078fbbbc84efc4d.svg";
export { ForwardRef as ReactComponent };